import { $t, i18n } from "./services/i18n";

// Definir los módulos según las variables de entorno
const modules = {
  guard: process.env.VUE_APP_GUARD === "true",
  carrier: process.env.VUE_APP_CARRIER === "true",
  patrol: process.env.VUE_APP_PATROL === "true",
  ctpat: process.env.VUE_APP_CTPAT === "true",
};

// Función para generar menús dinámicamente
const getMenus = () => ({
  navbarTopRight: [],
  navbarTopLeft: [],
  navbarSideLeft: [
    {
      to: "/home",
      label: $t("home"),
      icon: "pi pi-home text-primary",
      iconcolor: "",
      target: "",
    }, // Sección Accesses (solo si guard está activo)
    ...(modules.guard
      ? [
        {
          label: $t("Accesses"),
          icon: "pi pi-sign-in text-primary",
          items: [
            {
              to: "/home/guard",
              label: $t("moduleGuard"),
              icon: "pi pi-chart-pie text-primary",
            },
            {
              to: "/accessrequests",
              label: $t("accessrequests"),
              icon: "pi pi-id-card text-primary",
            },
            {
              to: "/accesslog",
              label: $t("accessLog"),
              icon: "pi pi-book text-primary",
            },
            {
              to: "/accessvip",
              label: $t("accessvip"),
              icon: "pi pi-star text-primary",
            },
            {
              to: "/accesslogvip",
              label: $t("accesslogvip"),
              icon: "pi pi-book text-primary",
            },
          ],
        },
      ]
      : []),
    // Sección Vendors (si guard o carrier están activos)
    ...(modules.guard || modules.carrier
      ? [
        {
          label: $t("vendors"),
          icon: "pi pi-building text-primary",
          items: [
            {
              to: "/vendors",
              label: $t("vendors"),
              icon: "pi pi-building text-primary",
            },
            {
              to: "/bitacora",
              label: $t("bitacora"),
              icon: "pi pi-book text-primary",
            },
            {
              to: "/employees",
              label: $t("employees"),
              icon: "pi pi-users text-primary",
            },
            {
              to: "/vehicles",
              label: $t("vehicles"),
              icon: "pi pi-car text-primary",
            },
            {
              to: "/tools",
              label: $t("tools"),
              icon: "pi pi-wrench text-primary",
            },
            {
              to: "/computers",
              label: $t("computers"),
              icon: "pi pi-desktop text-primary",
            },
            {
              to: "/sua",
              label: $t("suaMenu"),
              icon: "pi pi-verified text-primary",
            },
          ],
        },
      ]
      : []),
    ...(modules.carrier
      ? [
        {
          label: $t("carriers"),
          icon: "pi pi-truck text-primary",
          items: [
            {
              label: $t("carrierOperations") || "Operaciones",
              icon: "pi pi-cog text-primary",
              items: [
                {
                  to: "/carriers/dashboard",
                  label: $t("dashboard") || "Dashboard",
                  icon: "pi pi-chart-pie text-primary",
                },
                {
                  to: "/carrierrequests",
                  label: $t("carrierrequests"),
                  icon: "pi pi-id-card text-primary",
                },
                {
                  to: "/carriers/map",
                  label: $t("carriersMap") || "Mapa General",
                  icon: "pi pi-map text-primary",
                },
              ],
            },
            {
              label: $t("carrierTracking") || "Seguimientos",
              icon: "pi pi-eye text-primary",
              items: [
                {
                  to: "/carriers/exports",
                  label: $t("carriersExports") || "Exportaciones",
                  icon: "pi pi-upload text-primary",
                },
                {
                  to: "/carriers/imports",
                  label: $t("carriersImports") || "Importaciones",
                  icon: "pi pi-download text-primary",
                },
                {
                  to: "/carriers/locals",
                  label: $t("carriersLocals") || "Locales",
                  icon: "pi pi-map-marker text-primary",
                },
                {
                  to: "/carriers/mass-reports",
                  label: $t("massReports") || "Reportes Masivos",
                  icon: "pi pi-file-export text-primary",
                },
              ],
            },
            {
              label: $t("carrierCatalogs") || "Catálogos",
              icon: "pi pi-database text-primary",
              items: [
                {
                  to: "/carrier-companies",
                  label: $t("carrierCompanies"),
                  icon: "pi pi-building text-primary",
                },
                {
                  to: "/carriers",
                  label: $t("carriers"),
                  icon: "pi pi-users text-primary",
                },
                {
                  to: "/carrier_vehicles",
                  label: $t("tractos"),
                  icon: "pi pi-truck text-primary",
                },
                {
                  to: "/boxes",
                  label: $t("boxes"),
                  icon: "pi pi-box text-primary",
                },
              ],
            },
            {
              label: $t("carrierLogs") || "Bitácoras",
              icon: "pi pi-book text-primary",
              items: [
                {
                  to: "/carrier_accesslog",
                  label: $t("carrier_accesslog"),
                  icon: "pi pi-book text-primary",
                },
                {
                  to: "/box_logs",
                  label: $t("boxLogs"),
                  icon: "pi pi-book text-primary",
                },
                {
                  to: "/seals_log",
                  label: $t("sealLogs"),
                  icon: "pi pi-book text-primary",
                },
              ],
            },
          ],
        },
      ]
      : []),
    ...(modules.ctpat
      ? [
        {
          to: "/inspections",
          label: $t("Inspection.plural") || "Inspections",
          icon: "pi pi-shield text-primary",
        },
      ]
      : []),
    // Sección Patrols (solo si patrol está activo)
    ...(modules.patrol
      ? [
        {
          label: $t("patrol"),
          icon: "pi pi-map-marker text-primary",
          items: [
            {
              to: "/home/patrol",
              label: $t("modulePatrol"),
              icon: "pi pi-chart-line text-primary",
            },
            {
              to: "/round",
              label: $t("rounds"),
              icon: "pi pi-compass text-primary",
            },
            {
              to: "/reports",
              label: $t("reports"),
              icon: "pi pi-file-pdf text-primary",
            },
            {
              to: "/finding",
              label: $t("findings"),
              icon: "pi pi-exclamation-circle text-primary",
            },
            {
              to: "/incidents",
              label: $t("incidents"),
              icon: "pi pi-exclamation-triangle text-primary",
            },
            {
              to: "/patrols",
              label: $t("roundRoute"),
              icon: "pi pi-directions text-primary",
            },
            {
              to: "/tags",
              label: $t("tags"),
              icon: "pi pi-tag text-primary",
            },
            {
              to: "/tasks",
              label: $t("tasks"),
              icon: "pi pi-list text-primary",
            },
          ],
        },
      ]
      : []),
    {
      label: $t("settings"),
      icon: "pi pi-cog text-primary",
      items: [
        {
          to: "/users",
          label: $t("users"),
          icon: "pi pi-users",
        },
        {
          to: "/userdepts",
          label: $t("departments"),
          icon: "pi pi-sitemap",
        },
        {
          to: "/vendorslevels",
          label: $t("vendorsCategories"),
          icon: "pi pi-bookmark",
        },
        //        {
        //          to: "/employee-categories",
        //          label: $t("employeeCategories"),
        //          icon: "pi pi-bookmark",
        //       },
        {
          to: "/accessrequestpriorities",
          label: $t("priorities"),
          icon: "pi pi-sort-alt",
        },
        {
          to: "/accessrequeststatus",
          label: $t("statusRequests"),
          icon: "pi pi-check-circle",
        },
        {
          to: "/userstatus",
          label: $t("statusUsers"),
          icon: "pi pi-check-circle",
        },
        {
          to: "/vendorsstatus",
          label: $t("statusVendors"),
          icon: "pi pi-check-circle",
        },
        {
          to: "/repsestatus",
          label: $t("statusRepse"),
          icon: "pi pi-check-circle",
        },
        {
          to: "/permissions",
          label: $t("permissions"),
          icon: "pi pi-th-large text-primary",
        },
        {
          to: "/roles",
          label: $t("roles"),
          icon: "pi pi-th-large text-primary",
        },
        {
          to: "/visit_approvers",
          label: $t("visitApprovers"),
          icon: "pi pi-user-edit text-primary",
        },
      ],
    },

    {
      label: $t("audits.label"),
      icon: "pi pi-file-edit text-primary",
      adminOnly: true,
      items: [
        {
          label: $t("Accesses"),
          icon: "pi pi-sign-in text-primary",
          items: [
            {
              to: "/audits/index/auditType/accessRequest",
              label: $t("accessrequests"),
              icon: "pi pi-id-card text-primary",
            },
          ],
        },

        {
          label: $t("vendors"),
          icon: "pi pi-building text-primary",
          items: [
            {
              to: "/audits/index/auditType/vendor",
              label: $t("vendors"),
              icon: "pi pi-building text-primary",
            },

            {
              to: "/audits/index/auditType/employee",
              label: $t("employees"),
              icon: "pi pi-users text-primary",
            },

            {
              to: "/audits/index/auditType/employeeForm",
              label: $t("employeeForms"),
              icon: "pi pi-book text-primary",
            },

            {
              to: "/audits/index/auditType/vehicle",
              label: $t("vehicles"),
              icon: "pi pi-car text-primary",
            },

            {
              to: "/audits/index/auditType/tool",
              label: $t("tools"),
              icon: "pi pi-wrench text-primary",
            },

            {
              to: "/audits/index/auditType/computer",
              label: $t("computers"),
              icon: "pi pi-desktop text-primary",
            },
          ],
        },

        {
          label: $t("patrols"),
          icon: "pi pi-directions text-primary",
          items: [
            {
              to: "/audits/index/auditType/round",
              label: $t("round"),
              icon: "pi pi-compass text-primary",
            },

            {
              to: "/audits/index/auditType/finding",
              label: $t("findings"),
              icon: "pi pi-exclamation-circle text-primary",
            },

            {
              to: "/audits/index/auditType/incident",
              label: $t("incident"),
              icon: "pi pi-exclamation-triangle text-primary",
            },

            {
              to: "/audits/index/auditType/patrol",
              label: $t("roundRoute"),
              icon: "pi pi-compass text-primary",
            },

            {
              to: "/audits/index/auditType/task",
              label: $t("task"),
              icon: "pi pi-list text-primary",
            },

            {
              to: "/audits/index/auditType/tag",
              label: $t("tag"),
              icon: "pi pi-tag text-primary",
            },
          ],
        },
        {
          label: $t("carriers"),
          icon: "pi pi-truck text-primary",
          items: [
            {
              to: "/audits/index/auditType/carrierRequest",
              label: $t("carrierrequests"),
              icon: "pi pi-truck text-primary",
            },

            {
              to: "/audits/index/auditType/carrierCompany",
              label: $t("carrierCompanies"),
              icon: "pi pi-building text-primary"
            },

            {
              to: "/audits/index/auditType/carriers",
              label: $t("carriers"),
              icon: "pi pi-building text-primary"
            },

            {
              to: "/audits/index/auditType/carrierVehicle",
              label: $t("tractos"),
              icon: "pi pi-truck text-primary",
            },

            {
              to: "/audits/index/auditType/box",
              label: $t("box"),
              icon: "pi pi-box text-primary",
            },
          ],
        },
      ],
    },

    {
      label: $t("assetCheckouts.title"),
      icon: "pi pi-box text-primary",
      to: "/asset_checkouts",
      items: [
        {
          label: $t("assetCheckouts.dashboardTitle"),
          to: "/asset_checkouts/dashboard",
          icon: "pi pi-chart-bar text-primary",
        },
        {
          label: $t("assetCheckouts.viewList"),
          to: "/asset_checkouts",
          icon: "pi pi-list text-primary",
        },
      ],
    },
  ],
  exportFormats: {
    print: {
      label: $t("print"),
      icon: "pi pi-print",
      type: "print",
      ext: "print",
    },
    pdf: {
      label: $t("pdf"),
      icon: "pi pi-file-pdf",
      type: "pdf",
      ext: "pdf",
    },
    excel: {
      label: $t("excel"),
      icon: "pi pi-file-excel",
      type: "excel",
      ext: "xlsx",
    },
    csv: {
      label: $t("csv"),
      icon: "pi pi-table",
      type: "csv",
      ext: "csv",
    },
  },
});

// Usar Proxy para hacer AppMenus reactivo a los cambios de idioma
export const AppMenus = new Proxy(
  {},
  {
    get(target, prop) {
      const menus = getMenus();
      return menus[prop];
    },
    ownKeys() {
      const menus = getMenus();
      return Object.keys(menus);
    },
    getOwnPropertyDescriptor(target, prop) {
      return {
        enumerable: true,
        configurable: true,
      };
    },
  },
);
